import { mmcAjax } from '@/common/js/mmcModule';
const baseurl = 'https://api.jisuchou.net/';

const getWithdrawInfo = function(projuuid) {
    const url = `${baseurl}mmc/withdrawals/check/${projuuid}`;
    const debuger = false;
    if (debuger) {
        const project = require('./mock/info2.json');
        return new Promise((resolve, reject) => {
            resolve(project);
        });
    }
    return mmcAjax({
        method: 'GET',
        url,
    });
};

const getWithdrawPreSubmit = function(projuuid) {
    const url = `${baseurl}mmc/withdrawals/preSubmit/${projuuid}`;
    const debuger = false;
    if (debuger) {
        const project = require('./mock/preSubmit.json');
        return new Promise((resolve, reject) => {
            resolve(project);
        });
    }
    return mmcAjax({
        method: 'GET',
        url,
    });
};

const postWithdrawSubmit = function(params) {
    const url = `${baseurl}mmc/withdrawals/submit`;
    const debuger = false;
    if (debuger) {
        const project = require('./mock/preSubmit.json');
        return new Promise((resolve, reject) => {
            resolve(project);
        });
    }
    return mmcAjax({
        method: 'POST',
        url,
        data: {
            project_uuid: params.projuuid,
            withdraw_token: params.withdraw_token,
        },
    });
};

export { getWithdrawInfo, getWithdrawPreSubmit, postWithdrawSubmit };
